module.exports = __webpack_public_path__ + "static/img/regular-achievement-bg.f7468b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/regular-achievement-bg.png
// module id = mrK9
// module chunks = 9